module.exports = __webpack_public_path__ + "static/media/person_logo_icon.278f12a3.svg";